import { ConditionView, Icon, Typography, Modal } from '@/shared/ui';

import { useArtifactLoader } from '@/hooks/useArtifactLoader';

import { UserRequest } from '@/api/types';

import api from '@/api';

import { useExtendedArtifactStrategy } from '../../../lib';

import './UserRequestExtendedArtifactModal.scss';

interface Props {
  userRequest: UserRequest;
  artifactType: keyof NonNullable<UserRequest['artifacts_extend']>;
  isModalOpen: boolean;
  closeModal: () => void;
}

export const UserRequestExtendedArtifactModal: React.FC<Props> = ({
  userRequest,
  artifactType,
  isModalOpen,
  closeModal,
}) => {
  const { isArtifactLoading, currentArtifactExtendLoading, downloadArtifact } = useArtifactLoader((type, key) =>
    api.downloadUserRequestArtifact(userRequest.id, type, key),
  );
  const { title, ArtifactCardContent } = useExtendedArtifactStrategy({ userRequest, artifactType });

  const artifactsByType = userRequest.artifacts_extend?.[artifactType];

  if (!artifactsByType) return null;

  return (
    <Modal
      open={isModalOpen}
      className="extended-artifacts-modal"
      size="lg"
      title={title}
      footer={null}
      onCancel={closeModal}
    >
      <div className="extended-artifacts-modal__list">
        {artifactsByType.map((extendedArtifact) => (
          <div className="artifact-card" key={extendedArtifact.key}>
            <div className="artifact-card__content">
              <ArtifactCardContent extendedArtifact={extendedArtifact} />
            </div>
            <button
              className="artifact-card__action"
              disabled={isArtifactLoading || currentArtifactExtendLoading === extendedArtifact.key}
              onClick={(): Promise<void> => downloadArtifact(artifactType, extendedArtifact.key)}
            >
              <ConditionView
                if={currentArtifactExtendLoading !== extendedArtifact.key}
                else={<Typography color="grey">Скачується...</Typography>}
              >
                <Icon name="download" width={24} height={24} color={isArtifactLoading ? 'grey' : 'blue'} />
                <Typography color={isArtifactLoading ? 'grey' : 'blue'}>Скачати</Typography>
              </ConditionView>
            </button>
          </div>
        ))}
      </div>
    </Modal>
  );
};
